import { Component } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular';
@Component({
    selector: 'options-supp',
    templateUrl: 'options-supp.component.html'
})
export class OptionsSuppComponent {
    options: any = [];
    bouncIn = false;
    language = localStorage.getItem('language');
    constructor(
        params: NavParams,
        private viewCtr : ViewController
    ) {
        this.options = params.get('options');
        setTimeout(
            () => {
                this.options[0].checked = true;
                this.bouncIn = true;
                setTimeout(
                    () => {
                        this.options[0].checked = false;
                        this.bouncIn = false;
                    }, 500
                )
            }, 500
        )
    }
    valider() {
        this.viewCtr.dismiss(this.options);
    }
}



// WEBPACK FOOTER //
// ./src/components/options-supp/options-supp.component.ts